import { render } from "./DingdanPage.vue?vue&type=template&id=f0de5b36&scoped=true"
import script from "./DingdanPage.vue?vue&type=script&lang=js"
export * from "./DingdanPage.vue?vue&type=script&lang=js"

import "./DingdanPage.vue?vue&type=style&index=0&id=f0de5b36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0de5b36"]])

export default __exports__